import React, { Component } from "react";
import Head from "next/head";
import { connect } from "react-redux";

import { getSupportIndex } from "@store/support/actions";
import Breadcrumbs from "@components/Breadcrumbs";
import Heading from "@components/Heading";
import TopArticles from "@containers/Support/TopArticles";
import Categories from "@containers/Support/Categories";
import TopFaqs from "@containers/Support/TopFaqs";
import SearchForm from "@containers/Support/SearchForm";
import SupportFooter from "@containers/Support/Footer";
import FullWidthSection from "@components/FullWidthSection";

class SupportIndexPage extends Component {
  render() {
    const { supportCategories, topSupportArticles, topSupportFaqs } =
      this.props;

    return (
      <>
        <Head>
          <title>{`Suport clienti`}</title>
        </Head>

        <Breadcrumbs
          className="pt-3"
          breadcrumbs={[
            {
              id: 1,
              level: 99,
              name: `Suport clienti`,
            },
          ]}
        />

        <SearchForm
          label={
            <Heading
              title="Cu ce te putem ajuta?"
              as="h1"
              display="h1"
              classesProp="text-center -tracking-0.54 lg:-tracking-1"
            />
          }
        />

        {supportCategories && (
          <section className="pt-6 pb-1 lg:py-6">
            <Categories items={supportCategories} />
          </section>
        )}

        {topSupportArticles && (
          <section className="py-6">
            <FullWidthSection
              backgroundColor="bg-newsletterYellow"
              padding="pt-6 pb-10 lg:py-12 px-4 xs:px-5"
            >
              <TopArticles items={topSupportArticles} />
            </FullWidthSection>
          </section>
        )}

        {topSupportFaqs && (
          <section className="py-1 lg:py-5">
            <TopFaqs items={topSupportFaqs} />
          </section>
        )}

        <SupportFooter />
      </>
    );
  }
}

SupportIndexPage.getInitialProps = async (ctx) => {
  const { reduxStore } = ctx;

  // Get data from store
  const { topArticles } = reduxStore.getState().support;
  const promises = [];

  // Load data
  !topArticles && promises.push(reduxStore.dispatch(getSupportIndex()));

  await Promise.all(promises);
};

SupportIndexPage.pageLayout = "default";
SupportIndexPage.layoutProps = {
  displaySearch: false,
};

export default connect((state) => ({
  supportCategories: state.support.categories,
  topSupportArticles: state.support.topArticles,
  topSupportFaqs: state.support.topFaqs,
}))(SupportIndexPage);
